import React from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";

const SubSideBar = (props) => {
  return (
    <SubSideBarContainer
      style={{
        top: props.top,
        ...props.style,
      }}
    >
      <SubSiderBarHeader>
        <SubSiderBarHeaderText>{props.title}</SubSiderBarHeaderText>
      </SubSiderBarHeader>
      <SubSiderBarContentWrapper>{props.children}</SubSiderBarContentWrapper>
    </SubSideBarContainer>
  );
};

export default SubSideBar;

const SubSideBarContainer = styled.div.attrs((props) => {})`
  position: absolute;
  top: 150px;
  left: 313px;
  width: 200px;
  height: fit-content;
  padding: 10px 0px;
  background-color: #272829;
  box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const SubSiderBarHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0px 16px;
`;

const SubSiderBarHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const SubSiderBarContentWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;
